import * as React from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';

const DoubleLinearProgress = () => {
  return (
    <div className='circular-progress-exist-sub-list-wrapper circular-progress-exist-sub-list'>
      <LinearProgress />
      <br />
      <LinearProgress />
    </div>
  );
};

export default React.memo(DoubleLinearProgress);
